module.exports = __webpack_public_path__ + "img/T1A_xh_3.7d659cf3.png";